import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiLayThemTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.THEM,
    method: "POST",
    data: payload
  });
}

export function callApiXoaTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.XOA,
    method: "DELETE",
    params: payload
  });
}

export function callApiSuaTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.SUA,
    method: "PUT",
    data: payload
  });
}

export function callApiLayDanhSachTinhThanhTrongVung(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.TINH_THANH_TRONG_VUNG,
    method: "POST",
    data: payload
  });
}


export function callApiLayDanhSachTinhThanhFree(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC_TINH_THANH.TINH_THANH_FREE,
    method: "POST",
    data: payload
  });
}
